module.exports = __webpack_public_path__ + "static/media/gallaxy-background-web.d48d800c.jpg";